import React from "react";
import "./Main.css";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
import { Link } from "react-scroll";

const Main = () => {
  const transition = { type: "spring", duration: 3 };
  const mobileS = window.innerWidth <= 768 ? true : false;
  return (
    <div className="main" id="home">
      <div className="blur main-blur"></div>
      <div className="left-side">
        <Header />

        <div className="the-best-sec">
          <motion.div
            initial={{ left: mobileS ? "158px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>the best fitness club in the town</span>
        </div>

        {/* --------------------------------main text-------------------------------- */}
        <div className="main-text">
          <div>
            <span className="outline-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>

          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>
        {/* ------------------------------figures------------------------------ */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={140} start={100} preFix="+" delay="4" />
            </span>
            <span>Expert Coaches</span>
          </div>
          <div>
            <span>
              <NumberCounter end={978} start={800} preFix="+" delay="4" />
            </span>
            <span>members joined</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} start={0} preFix="+" delay="4" />
            </span>
            <span>fitness programms</span>
          </div>
        </div>

        <div className="main-button">
          <button className="btn">
            <Link to="join" span={true} smooth={true}>
              Get Started
            </Link>
          </button>
          <button className="btn">
            <Link to="programs" span={true} smooth={true}>
              Learn More
            </Link>
          </button>
        </div>
      </div>
      <div className="right-side">
        <button className="btn">
          <Link to="join" span={true} smooth={true}>
            Join Now
          </Link>
        </button>
        <motion.div
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={transition}
          className="heart-rate"
        >
          <img src={heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>

        {/*------------------------- Main Image Section-------------------------- */}

        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "20rem" }}
          transition={transition}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />
        <motion.div
          initial={{ right: "37rem" }}
          whileInView={{ right: "28rem" }}
          transition={transition}
          className="calories"
        >
          {/* -----------------------------Calories---------------------------------- */}
          <img src={calories} alt="" />
          <div>
            <span>Calories burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Main;
